import { Html, Image } from "@custom/schema";
import clsx from "clsx";
import React from "react";
import Video from "../molecules/Video";
export default function TwoColMedia(props) {
    return /*#__PURE__*/ React.createElement("div", {
        className: "page-container-lg mb-10 md:my-16 lg:mb-28 lg:mt-20 overflow-hidden relative"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "max-w-7xl mx-auto relative z-10"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "pb-8 lg:pb-20 mb-10 lg:mb-20 last:pb-0 last:mb-0"
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("lg:flex lg:gap-x-9", {
            "flex-row-reverse": props.imageAlignment === "right"
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: "lg:w-1/2"
    }, props.videoSource && /*#__PURE__*/ React.createElement(Video, {
        displayInline: props.displayInline,
        url: props.videoSource,
        thumbnail: props.thumbnail
    }), props.image && /*#__PURE__*/ React.createElement(Image, {
        source: props.image.source,
        alt: props.image.alt,
        className: "w-full max-w-full mb-9 lg:mb-0"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "lg:w-1/2 mb-2 lg:mb-0"
    }, props.sectionHeading && /*#__PURE__*/ React.createElement("h3", {
        className: "text-2xl md:text-3xl lg:text-4xl lg:leading-tight font-medium mb-2 md:mb-4"
    }, props.sectionHeading), props.subheading && /*#__PURE__*/ React.createElement("p", {
        className: "block lg:text-xl mb-1.5"
    }, /*#__PURE__*/ React.createElement("strong", null, props.subheading)), (props.description || props.moreContent) && /*#__PURE__*/ React.createElement("div", {
        className: "block text-lg prose prose-two-col"
    }, props.description && /*#__PURE__*/ React.createElement(Html, {
        markup: props.description
    }), props.moreContent && /*#__PURE__*/ React.createElement("div", {
        dangerouslySetInnerHTML: {
            __html: props.moreContent
        }
    })), props.cta && props.cta.label && /*#__PURE__*/ React.createElement("a", {
        href: "".concat(props.cta.target),
        className: "button-secondary mt-6 w-full sm:w-auto border-gray-600 text-white bg-gray-600 hover:text-gray-600 hover:bg-white md:px-10"
    }, props.cta.label))))));
}
